import { render } from "./TestFrame.vue?vue&type=template&id=7b14fb7a&scoped=true&ts=true"
import script from "./TestFrame.vue?vue&type=script&lang=ts"
export * from "./TestFrame.vue?vue&type=script&lang=ts"

import "./TestFrame.vue?vue&type=style&index=0&id=7b14fb7a&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b14fb7a"]])

export default __exports__